import React from "react";

//Jds
import { Container } from "@jds/core";

// Local
import UserSidepanel from "./UserSidepanel/UserSidepanel";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

export default function UserDetailsLayout(props) {
  return (
    <Container direction="row" fullWidth>
      <UserSidepanel />
      <Box
        // p="32px 64px"
        p="32px 72px"
        // pr={"128px"}
        // style={{ flex: 1 }}
        // maxWidth={1158}
        mt={"72px"}
        sx={{
          flex: 1,
          // width: "680px",
          // maxWidth: "1158px",
        }}
      >
        <Outlet />
      </Box>
    </Container>
  );
}
